import {isDonationTicketDefinition} from '@wix/wix-events-commons-statics'
import type {TFunction} from 'react-i18next'
import type {PriceFormatters} from '../../../../../commons/hooks/currency'
import {State} from '../../types/state'
import {getTickets} from '../tickets'
import {getPlaceTicketPriceText} from './place'
import {getTicketDefinitionByExternalId} from './seating'

export interface LegendItem {
  name: string
  color: string
  price: string
}

export const getLegendItems = (
  state: State,
  t: TFunction,
  {getTicketPriceText, getFormattedMoney}: PriceFormatters,
): LegendItem[] =>
  state.seating.plan.categories
    .filter(category => Boolean(category.places.length))
    .map(({externalId, config: {color}}) => {
      const ticketDefinition = getTicketDefinitionByExternalId(getTickets(state), externalId)

      if (!ticketDefinition) {
        return null
      }

      const isDonation = isDonationTicketDefinition(ticketDefinition)

      return {
        name: ticketDefinition.name,
        color,
        price: getPlaceTicketPriceText({
          ticket: ticketDefinition,
          t,
          getTicketPriceText,
          getFormattedMoney,
        }),
        amount: isDonation ? 0 : Number(ticketDefinition.price.amount),
      }
    })
    .filter(Boolean)
    .sort((a, b) => a.amount - b.amount)
